
<template>
  <!--联盟活动-->
  <div>
    <x-tabula
      ref="table"
      apiOrigin="PHP"
      :dataSource="dataSource"
      rowKey="activity_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_o" slot-scope="{row}">
        <template v-if="row.page_start_time && row.page_end_time">
        <div>{{`开始：${row.page_start_time}`}}</div>
        <div>{{`结束：${row.page_end_time}`}}</div>
        </template>
      </template>
    </x-tabula>

    <!--新增活动的弹窗-->
    <a-modal
      title="新增活动"
      :visible="visible"
      @cancel="visible=false"
      @ok="submitHandle"
      :confirmLoading="btnLoading.loading"
      v-bind="$store.state.modalConfig"
    >
        <a-form :form="form">
          <a-form-item v-bind="itemLayout" label="平台">
            <a-select
              v-decorator="['platform', { initialValue: 1, rules: [{ required: true, message: '请选择平台' }] }]"
              :filterOption="filterOption"
              showSearch
              allowClear
              :disabled="true"
              placeholder="请选择平台"
            >
              <a-select-option v-for="(item, index) of platformList" :key="index" :value="item.value">
                {{item.label}}
              </a-select-option>
            </a-select>
          </a-form-item>

            <a-form-item label="活动标题" v-bind="itemLayout">
                <a-input v-decorator="['title', {rules: [{ required: true, message: '请输入活动标题' }, {pattern: this.REG.nonEmpty, message: this.MESSAGE.nonEmpty}]}]" placeholder="请输入活动标题"/>
            </a-form-item>

          <a-form-item label="活动ID" v-bind="itemLayout">
            <a-input v-decorator="['activity_material_id', {rules: [{ required: true, message: '请输入活动ID' }, {pattern: this.REG.nonEmpty, message: this.MESSAGE.nonEmpty}]}]" placeholder="请输入活动ID"/>
          </a-form-item>
        </a-form>
    </a-modal>

    <!--推广的弹窗-->
    <a-modal
      title="推广"
      :visible="spreadVisible"
      @cancel="closeSpreadModal"
      v-bind="$store.state.modalConfig"
    >
      <template slot="footer">
        <a-button type="primary" @click="closeSpreadModal">确定</a-button>
      </template>

      <a-form :form="spreadForm">
        <a-form-item v-bind="itemLayout" label="平台">
          <a-radio-group @change="platFormChange" v-decorator="['platform', { initialValue: '1' }]">
            <a-radio value="1">iOS</a-radio>
            <a-radio value="2">Android</a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item v-bind="itemLayout" label="短链接">
          <a-row type="flex" :gutter="10">
            <a-col span="18">
              <a-input id="shortLink" v-model="linkType.shortLink" placeholder=""></a-input>
            </a-col>
            <a-col>
              <a-button class="shortLink" data-clipboard-target="#shortLink" type="primary">复制</a-button>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item v-bind="itemLayout" label="长链接">
          <a-row type="flex" :gutter="10">
            <a-col span="18">
              <a-input id="longLink" v-model="linkType.longLink" placeholder=""></a-input>
            </a-col>
            <a-col>
              <a-button class="longLink" data-clipboard-target="#longLink" type="primary">复制</a-button>
            </a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { inputSearch } from 'ant-design-vue-admin-x';
import ClipboardJS from 'clipboard';
export default {
  name: 'activity',
  mixins: [inputSearch],
  data () {
    return {
      instance: {},
      spreadVisible: false,
      linkType: {},
      urlObj: {
        android_click_url: '',
        android_short_click_url: '',
        ios_click_url: '',
        ios_short_click_url: ''
      },
      visible: false,
      btnLoading: {loading: false},
      platformList: [{ label: '淘宝', value: 1 }],

      /** table 参数 */
      searchList: [
        { props: ['keywords'], placeholder: '活动名称', options: [], inputType: 'input' }
      ],
      tableOptList: [
        { text: '新增', handle: this.openModal, icon: 'plus', permi: ['community:activity:add'] }
      ],
      rowOptList: [
        {text: '推广', handle: (row) => this.handleSpread(row), permi: ['community:activity:spread']},
        {
          text: '下载素材',
          handle: (row) => this.downloadMaterial(row),
          rowOptDisHandle: row => !row.material_oss_url,
          permi: ['community:activity:download']
        },
        {text: '删除', handle: (row) => this.$refs.table.showDeleteConfirm(row), permi: ['community:activity:remove']}
      ],
      columns: [
        { title: '平台', dataIndex: 'platform_desc', align: 'left', width: '' },
        { title: '活动名称', dataIndex: 'title', align: 'left', width: '' },
        { title: '访客数', dataIndex: 'member_view_sum', align: 'left', width: '' },
        { title: '浏览量', dataIndex: 'pageview', align: 'left', width: '' },
        { title: '活动时间', dataIndex: 'page_start_time', align: 'left', width: '', scopedSlots: {customRender: 'o'} },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        keywords: undefined
      },
      listApi: {
        url: '/market/activity',
        resHandle: this.listResHandle,
        searchHandle: '' // searchHandle
      },
      addHandleParam: {},
      deleteParam: {
        url: '/market/activity',
        param: {pk_key: 'activity_id', pk_val: ''},
        title: '活动',
        key: 'title'
      }
    };
  },
  computed: {
    itemLayout () {
      return this.$store.state.modal_ItemLayout;
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
    this.spreadForm = this.$form.createForm(this);
  },
  created () {
  },
  methods: {
    /** 打开弹窗 */
    openModal () {
      this.visible = true;
    },
    /** 提交新增活动 */
    submitHandle () {
      this.form.validateFields((err, values) => {
        if (err) { return; }
        this._post({
          url: '/market/activity',
          params: values
        }).then(({data}) => {
          this.$message.success('新增成功');
          this.visible = false;
          this.$refs.table.getTableList();
        });
      });
    },
    /** 推广弹窗的平台切换 */
    platFormChange (e) {
      if (e.target) {
        e = e.target.value;
      }
      if (e === '1') {
        this.linkType = {
          shortLink: this.urlObj.ios_short_click_url,
          longLink: this.urlObj.ios_click_url
        };
      } else {
        this.linkType = {
          shortLink: this.urlObj.android_short_click_url,
          longLink: this.urlObj.android_click_url
        };
      }
    },
    /** 广播推广弹窗 */
    closeSpreadModal () {
      this.spreadVisible = false;
      for (let item in this.instance) {
        this.instance[item].destroy();
      }
    },
    /** 打开推广弹窗 */
    handleSpread (row) {
      this.spreadVisible = true;
      for (let item in this.urlObj) {
        if (row.hasOwnProperty(item)) {
          this.urlObj[item] = row[item];
        }
      }
      this.platFormChange('1');
      this.$nextTick(() => {
        this.handleCopy('.shortLink');
        this.handleCopy('.longLink');
      });
    },
    /** 处理复制事件 */
    handleCopy (element) {
      this.instance[element] = new ClipboardJS(element);
      this.instance[element].on('success', (e) => {
        this.$message.success('已复制');
        e.clearSelection();
      });

      this.instance[element].on('error', (e) => {
        this.$message.error('复制失败');
      });
    },
    /** 下载素材 */
    downloadMaterial (row) {
      if (row.material_oss_url) {
        let a = document.createElement('a');
        a.href = row.material_oss_url;
        a.click();
      }
    },
    listResHandle (res) {
      res.forEach((el) => {
        el.platform_desc = el.platform === 1 ? '淘宝' : '京东';
      });
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
